export { default } from './PropertyExpenses';
